// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const ActionPlan = () => {
//   const { t } = useTranslation();
//   const rows = t('actionPlan.rows', { returnObjects: true });


//     return (
      
//       <div>
//       <div className="action-plan">
//         <header className="action-plan__header">
//           <h1 className="action-plan__title">{t('actionPlan.title')}</h1>
//           <p className="action-plan__subtitle">{t('actionPlan.subtitle')}</p>
//         </header>

//         <table className="action-plan__table">
//           <thead className="action-plan__table-head">
//             <tr className="action-plan__table-row">
//               <th className="action-plan__table-header">{t('actionPlan.tableHeaders.number')}</th>
//               <th className="action-plan__table-header">{t('actionPlan.tableHeaders.task')}</th>
//               <th className="action-plan__table-header">{t('actionPlan.tableHeaders.details')}</th>
//               <th className="action-plan__table-header">{t('actionPlan.tableHeaders.deadline')}</th>
//             </tr>
//           </thead>
//           <tbody className="action-plan__table-body">
//             {rows.map((row, index) => (
//               <tr className="action-plan__table-row" key={index}>
//                 <td className="action-plan__table-data">{row.number}</td>
//                 <td className="action-plan__table-data">{row.task}</td>
//                 <td className="action-plan__table-data">
//                   <ul className="action-plan__list">
//                     {row.details.map((detail, i) => (
//                       <li key={i}>{detail}</li>
//                     ))}
//                   </ul>
//                 </td>
//                 <td className="action-plan__table-data">{row.deadline}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//     );
// }

// export default ActionPlan;

// ActionPlan.jsx


import React, { useState } from 'react';
import styled from 'styled-components';
import { Download } from 'lucide-react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// Styled components остаются без изменений...
const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 2rem;
`;

const Container = styled.div`
  max-width: 1024px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.25rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 2rem;
`;

const CardTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
`;

const CardSubtitle = styled.p`
  color: #6b7280;
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;

const Content = styled.div`
  color: #4b5563;
  line-height: 1.6;
  
  p {
    margin-bottom: 1rem;
  }
`;

const List = styled.div`
  padding-left: 1.5rem;
  margin: 1rem 0;
  
  p {
    margin-bottom: 0.5rem;
  }
`;

const Alert = styled.div`
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 2rem;
  color: #374151;
`;

const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`;

const ActionPlan = () => {
  const { t, i18n } = useTranslation(); // Добавляем i18n
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Объект с путями к документам для разных языков
  const documentPaths = {
    ru: '/documents/actionplanru.pdf',
    tj: '/documents/actionplantj.pdf'
  };

  const handleDownload = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const currentLang = i18n.language;
      const documentPath = documentPaths[currentLang] || documentPaths.ru; // По умолчанию русский
      
      // Получаем документ с помощью fetch
      const response = await fetch(documentPath);
      if (!response.ok) throw new Error(t('errors.downloadError'));
      
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      
      // Формируем имя файла в зависимости от языка
      const fileName = `actionplan${currentLang}.pdf`;
      
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      
    } catch (err) {
      console.error('Ошибка:', err);
      setError(t('errors.downloadError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper>
      <Container>
        <Title>
          {t('actionPlann.title')}
        </Title>

        <Card>
          <CardTitle>
            {t('actionPlann.about.title')}
          </CardTitle>
          <CardSubtitle>
            {t('actionPlann.about.subtitle')}
          </CardSubtitle>
          <Content>
            <p>{t('actionPlann.about.description')}</p>
            <p>{t('actionPlann.about.directions.title')}</p>
            <List>
              {t('actionPlann.about.directions.items', { returnObjects: true }).map((item, index) => (
                <p key={index}>• {item}</p>
              ))}
            </List>
          </Content>
        </Card>
        <Alert>
          {error ? (
            <div style={{ color: 'red' }}>{error}</div>
          ) : (
            loading ? t('actionPlann.loading') : t('actionPlann.downloadInfo')
          )}
        </Alert>

        <DownloadButton onClick={handleDownload} disabled={loading}>
          <Download size={20} />
          {loading ? t('actionPlann.buttonLoading') : t('actionPlann.buttonText')}
        </DownloadButton>

      </Container>
    </PageWrapper>
  );
};

export default ActionPlan;